import { render, staticRenderFns } from "./ProductSubCategoryAddView.vue?vue&type=template&id=019a0abd&scoped=true&"
import script from "./ProductSubCategoryAddView.vue?vue&type=script&lang=js&"
export * from "./ProductSubCategoryAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a0abd",
  null
  
)

export default component.exports